import { type RefObject, useEffect } from 'react';

function useResizeObserver(
  container: RefObject<HTMLDivElement>,
  callback: (params: { width: number; height: number }) => void
) {
  useEffect(() => {
    const element = container.current;

    if (!element) {
      return;
    }

    const resizeObserver = new ResizeObserver((entries) => {
      if (!Array.isArray(entries) || !entries.length) {
        return;
      }

      const [entry] = entries;

      if (entry) {
        const {
          contentRect: { width, height },
        } = entry;

        callback({ width, height });
      }
    });

    resizeObserver.observe(element);

    return () => resizeObserver.unobserve(element);
  }, [callback, container]);
}

export default useResizeObserver;
